import React from 'react';

const MaterailRequestModal = () => {
	return (
		<div className="popup-wrapper">
			<div className="common-popup material-request-details-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-14 mb-0">Enter material request details</h3>
					</div>
					<div className="close-btn">
						<img src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<div className="choose-puprpose-box">
						<p className="regular-14 gray_dark_01 mb-2">Choose purpose</p>
						<div className="row">
							<div className="col-md-12">
								<div className="custom-radio-box">
									<div className="form-group d-flex align-items-center">
										<input type="radio" className="" id="purpose" name="purpose" />
										<label
											htmlFor="purpose"
											className="ml-2 mb-0 gray_dark_01 regular-14"
										>
											Nitex development
										</label>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="custom-radio-box">
									<div className="form-group d-flex align-items-center">
										<input type="radio" className="" id="2" name="purpose" />
										<label htmlFor="2" className="ml-2 mb-0 gray_dark_01 regular-14">
											Buyer sample request{' '}
										</label>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="custom-radio-box">
									<div className="form-group d-flex align-items-center">
										<input type="radio" className="" id="3" name="purpose" />
										<label htmlFor="3" className="ml-2 mb-0 gray_dark_01 regular-14">
											P&C
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="choose-purpose-box">
						<p className="regular-14 gray_dark_01 mb-2">Choose type of material:</p>
						<div className="row">
							<div className="col-md-12">
								<div className="custom-radio-box">
									<div className="form-group d-flex align-items-center">
										<input type="radio" className="" id="purpose" name="purpose" />
										<label
											htmlFor="purpose"
											className="ml-2 mb-0 gray_dark_01 regular-14"
										>
											Fabric
										</label>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="custom-radio-box">
									<div className="form-group d-flex align-items-center">
										<input type="radio" className="" id="2" name="purpose" />
										<label htmlFor="2" className="ml-2 mb-0 gray_dark_01 regular-14">
											Swatch{' '}
										</label>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="custom-radio-box">
									<div className="form-group d-flex align-items-center">
										<input type="radio" className="" id="3" name="purpose" />
										<label htmlFor="3" className="ml-2 mb-0 gray_dark_01 regular-14">
											Trims & Accessories{' '}
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default MaterailRequestModal;
